import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import Communications from '../../../images/Communications.svg';
import MarkFollowUp from '../../../images/MarkFollowUp.svg';
import { CloseSquareTwoTone } from '@ant-design/icons';
import SendCommsModal from "./SendCommsModal";
import FollowUpModal from "./MarkFollowUpModal";
import CancelOrderModal from "./CancelOrderModal";
import { pharmacyOpsActions } from "../../../constant";


const PharmacyActions = ({orderId, allowedActions}) => {
    const [showSendCommsPopup, setShowSendCommsPopup] = React.useState(false);
    const [showFollowUpPopup, setShowFollowUpPopup] = React.useState(false);
    const [showCancelOrderPopup, setShowCancelOrderPopup] = React.useState(false);

    const handlePopUps = (action) => {
        console.log('vnd',action)
        if( action == 'send-comms'){
            setShowFollowUpPopup(false);
            setShowCancelOrderPopup(false);
            setShowSendCommsPopup(true);
        }else if (action == 'mark-follow-up'){
            setShowSendCommsPopup(false);
            setShowCancelOrderPopup(false);
            setShowFollowUpPopup(true);
        }else if(action == 'close-popup'){
            setShowSendCommsPopup(false);
            setShowFollowUpPopup(false);
            setShowCancelOrderPopup(false);
        }else if(action == 'cancel-order'){
            setShowSendCommsPopup(false);
            setShowFollowUpPopup(false);
            setShowCancelOrderPopup(true);
        }
    }

    const canCancel = allowedActions.includes(pharmacyOpsActions.CANCEL_ORDER);

    const ActionBtn = ({ id, tooltip, onClick, disabled, children, variant = 'ghost' }) => {
        const base = {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '28px',
            height: '28px',
            borderRadius: '6px',
            border: 'none',
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.4 : 1,
            transition: 'background 0.15s',
            background: 'transparent',
            flexShrink: 0,
        };
        const variants = {
            ghost:  { background: 'transparent' },
            danger: { background: '#FFF0F0' },
            blue:   { background: '#EFF6FF' },
            amber:  { background: '#FFFBF0' },
        };
        return (
            <>
                <UncontrolledTooltip target={id} placement="top">
                    {tooltip}
                </UncontrolledTooltip>
                <button
                    id={id}
                    onClick={disabled ? undefined : onClick}
                    style={{ ...base, ...variants[variant] }}
                >
                    {children}
                </button>
            </>
        );
    };

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>

                <ActionBtn
                    id={`pharmacy-cancel-order-${orderId}`}
                    tooltip="Cancel Order"
                    onClick={() => handlePopUps('cancel-order')}
                    disabled={!canCancel}
                    variant="danger"
                >
                    <CloseSquareTwoTone
                        twoToneColor={canCancel ? ['#EB5757', '#FFF0F0'] : ['#ccc', '#f5f5f5']}
                        style={{ fontSize: '16px' }}
                    />
                </ActionBtn>

                <ActionBtn
                    id={`pharmacy-action-send-comms-${orderId}`}
                    tooltip="Send Communication"
                    onClick={() => handlePopUps('send-comms')}
                    variant="blue"
                >
                    <img src={Communications} alt="Send Communication" style={{ width: '16px', height: '16px' }} />
                </ActionBtn>

                <ActionBtn
                    id={`pharmacy-action-mark-follow-up-${orderId}`}
                    tooltip="Mark Follow Up"
                    onClick={() => handlePopUps('mark-follow-up')}
                    variant="amber"
                >
                    <img src={MarkFollowUp} alt="Mark Follow Up" style={{ width: '16px', height: '16px' }} />
                </ActionBtn>

            </div>

            {showCancelOrderPopup && <CancelOrderModal orderId={orderId} onClose={handlePopUps} />}
            {showSendCommsPopup && <SendCommsModal orderId={orderId} onClose={handlePopUps} />}
            {showFollowUpPopup && <FollowUpModal isOpen orderId={orderId} onClose={handlePopUps} />}
        </>
    )

}
export default PharmacyActions;